/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_SummaryInputs */

const en_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing with your natural athletic ability and rhythm; avoid building the swing position by position, which tends to create tension and disconnection.`)
};

const es_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swinguea con tu capacidad atlética natural y tu ritmo; evita construir el swing posición por posición, lo que suele crear tensión y desconexión.`)
};

const de_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwingen Sie mit Ihren natürlichen sportlichen Fähigkeiten und Ihrem Rhythmus; vermeiden Sie es, den Schwung Position für Position aufzubauen, da dies zu Spannungen und Unterbrechungen führen kann.`)
};

const zh_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用你天生的运动能力和节奏挥杆；不要一个位置一个位置地拼凑挥杆，那样往往会造成紧张和动作脱节。`)
};

const ar_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نفّذ السوينغ بقدرتك الرياضية الطبيعية وإيقاعك؛ تجنّب بناء السوينغ وضعية بوضعية، فذلك غالباً يخلق توتراً وانفصالاً.`)
};

const fr_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swinguez avec votre capacité athlétique naturelle et votre rythme ; évitez de construire le swing position par position, ce qui tend à créer des tensions et une perte de connexion.`)
};

const vi_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing bằng khả năng thể thao tự nhiên và nhịp điệu của bạn; tránh dựng swing từng vị trí một, điều thường tạo căng và mất liên kết.`)
};

const sw_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piga swing kwa uwezo wako wa asili wa kimichezo na mdundo wako; epuka kujenga swing mkao mmoja baada ya mwingine, kwa sababu hilo huelekea kuleta mkazo na kukatika kwa mwendo.`)
};

const th_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวิงด้วยความสามารถทางกีฬาและจังหวะที่เป็นธรรมชาติของคุณ หลีกเลี่ยงการสร้างสวิงทีละตำแหน่ง ซึ่งมักทำให้เกิดความตึงเกร็งและการเคลื่อนไหวที่ขาดความต่อเนื่อง`)
};

const bs_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swinguj svojom prirodnom atletskom sposobnošću i ritmom; izbjegavaj građenje swinga položaj po položaj, što često stvara napetost i diskonektovanost.`)
};

const ja_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本来の運動能力とリズムでスイングしましょう。位置ごとにスイングを組み立てると、緊張と分断が生まれやすくなります。`)
};

const ko_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자연스러운 운동 능력과 리듬으로 스윙하세요. 자세를 하나하나 쌓아 올리면 긴장과 단절이 생기기 쉽습니다.`)
};

const pt_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça o swing com a sua capacidade atlética natural e o seu ritmo; evite montar o swing posição por posição, o que tende a criar tensão e desconexão.`)
};

const it_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai lo swing con la tua naturale capacità atletica e il tuo ritmo; evita di costruire lo swing una posizione alla volta, perché tende a creare tensione e scollegamento.`)
};

const sv_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svinga med din naturliga atletiska förmåga och rytm; undvik att bygga svingen position för position, eftersom det ofta skapar spänning och avbrott.`)
};

const nl_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing met je natuurlijke atletische vermogen en ritme; vermijd de swing houding voor houding op te bouwen, want dat zorgt vaak voor spanning en onderbreking.`)
};

const da_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sving med din naturlige atletiske evne og rytme; undgå at bygge svinget position for position, for det skaber typisk spænding og afbrydelse.`)
};

const nb_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sving med din naturlige atletiske evne og rytme; unngå å bygge svingen posisjon for posisjon, for det skaper typisk spenning og avbrudd.`)
};

const fi_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svingaa luontaisella urheilullisuudellasi ja rytmilläsi; älä rakenna svingiä asento kerrallaan, koska se luo helposti jännitystä ja katkonaisuutta.`)
};

const pl_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swinguj, korzystając z naturalnych zdolności sportowych i rytmu; unikaj budowania swingu pozycja po pozycji, bo zwykle prowadzi to do napięcia i utraty płynności.`)
};

const ru_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполняйте свинг, опираясь на природную атлетичность и ритм; не собирайте свинг позиция за позицией — это обычно создаёт напряжение и разрывает движение.`)
};

const tr_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğal atletik yeteneğiniz ve ritminizle swing yapın; swingi pozisyon pozisyon kurmaktan kaçının, çünkü bu genellikle gerilim ve kopukluk yaratır.`)
};

const hi_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी स्वाभाविक एथलेटिक क्षमता और लय से स्विंग करें; स्विंग को पोज़िशन दर पोज़िशन न बनाएँ—इससे तनाव और विच्छेद पैदा होता है।`)
};

const id_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayunkan stik dengan kemampuan atletis dan ritme alami Anda; hindari membangun ayunan posisi demi posisi, karena cara itu cenderung menimbulkan ketegangan dan gerakan yang terputus-putus.`)
};

const ms_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayun dengan kebolehan atletik dan rentak semula jadi anda; elakkan membina hayunan satu kedudukan demi satu kedudukan, kerana cara itu cenderung menimbulkan ketegangan dan gerakan yang terputus.`)
};

const cs_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Švihejte se svou přirozenou sportovní schopností a rytmem; nestavějte švih pozici po pozici, protože to obvykle vede k napětí a nesouvislému pohybu.`)
};

const el_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάντε σβινγκ με τη φυσική αθλητική σας ικανότητα και τον ρυθμό σας· αποφύγετε να χτίζετε το σβινγκ θέση-θέση, γιατί αυτό τείνει να δημιουργεί ένταση και αποσύνδεση.`)
};

const he_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בצעו סווינג עם היכולת האתלטית והקצב הטבעיים שלכם; הימנעו מבניית הסווינג תנוחה אחר תנוחה, כי זה נוטה ליצור מתח וחוסר רציפות.`)
};

const af_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swaai met jou natuurlike atletiese vermoë en ritme; vermy om die swaai posisie vir posisie te bou, wat geneig is om spanning en ontkoppeling te skep.`)
};

const hu_method_content_step_02_summary = /** @type {(inputs: Method_Content_Step_02_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üss a természetes atletikus képességeddel és ritmusoddal; ne építsd a swinget pozícióról pozícióra, mert az feszültséget és szétesést szül.`)
};

/**
* | output |
* | --- |
* | "Swing with your natural athletic ability and rhythm; avoid building the swing position by position, which tends to create tension and disconnection." |
*
* @param {Method_Content_Step_02_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_summary = /** @type {((inputs?: Method_Content_Step_02_SummaryInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_SummaryInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_summary(inputs)
	if (locale === "de") return de_method_content_step_02_summary(inputs)
	if (locale === "zh") return zh_method_content_step_02_summary(inputs)
	if (locale === "ar") return ar_method_content_step_02_summary(inputs)
	if (locale === "fr") return fr_method_content_step_02_summary(inputs)
	if (locale === "vi") return vi_method_content_step_02_summary(inputs)
	if (locale === "sw") return sw_method_content_step_02_summary(inputs)
	if (locale === "th") return th_method_content_step_02_summary(inputs)
	if (locale === "bs") return bs_method_content_step_02_summary(inputs)
	if (locale === "ja") return ja_method_content_step_02_summary(inputs)
	if (locale === "ko") return ko_method_content_step_02_summary(inputs)
	if (locale === "pt") return pt_method_content_step_02_summary(inputs)
	if (locale === "it") return it_method_content_step_02_summary(inputs)
	if (locale === "sv") return sv_method_content_step_02_summary(inputs)
	if (locale === "nl") return nl_method_content_step_02_summary(inputs)
	if (locale === "da") return da_method_content_step_02_summary(inputs)
	if (locale === "nb") return nb_method_content_step_02_summary(inputs)
	if (locale === "fi") return fi_method_content_step_02_summary(inputs)
	if (locale === "pl") return pl_method_content_step_02_summary(inputs)
	if (locale === "ru") return ru_method_content_step_02_summary(inputs)
	if (locale === "tr") return tr_method_content_step_02_summary(inputs)
	if (locale === "hi") return hi_method_content_step_02_summary(inputs)
	if (locale === "id") return id_method_content_step_02_summary(inputs)
	if (locale === "ms") return ms_method_content_step_02_summary(inputs)
	if (locale === "cs") return cs_method_content_step_02_summary(inputs)
	if (locale === "el") return el_method_content_step_02_summary(inputs)
	if (locale === "he") return he_method_content_step_02_summary(inputs)
	if (locale === "af") return af_method_content_step_02_summary(inputs)
	if (locale === "hu") return hu_method_content_step_02_summary(inputs)
	return en_method_content_step_02_summary(inputs)
});